
import FeedbackMarkdownText from "./FeedbackMarkdownText";

export default function FeedbackSummaryContent({ text }) {

  return (
    
    <FeedbackMarkdownText
      text={text}
      className="summary-feedback-item"
      components={{
        ul: ({ children }) => <ul className="summary-feedback-list">{children}</ul>,
        li: ({ children }) => <li className="summary-feedback-item">{children}</li>,
      }}
    />
  );
}
